import { Component, OnInit } from '@angular/core';
import {MenuController, ModalController} from "@ionic/angular";
import {Router} from "@angular/router";

@Component({
  selector: 'app-pharmacy-map',
  templateUrl: './pharmacy-map.component.html',
  styleUrls: ['./pharmacy-map.component.scss'],
})
export class PharmacyMapComponent implements OnInit {

  constructor(private modalController: ModalController, private route: Router, private menu: MenuController) { }

  ngOnInit() {
  }

  medicaldetail() {
    this.modalController.dismiss();
    this.route.navigate(['./medicaldetail']);
  }

  dismiss(){
    this.modalController.dismiss();
  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }
}
